import PropTypes from 'prop-types';

/**
 * Radio-button custom field. One option at a time, stored as the option's own
 * text so the value matches what a public intake form submits for the field.
 */
export const CustomFieldRadioGroup = ({ name, options, value, onChange }) => {
  const selected = String(value ?? '').trim().toLowerCase();

  return (
    <div>
      {options.map((opt, index) => {
        const optionId = `${name}-${String(opt).toLowerCase()}`;
        return (
          <div key={`${optionId}-${index}`} className="flex items-center mb-2">
            <input
              type="radio"
              id={optionId}
              name={name}
              value={opt}
              checked={selected === String(opt).toLowerCase()}
              onChange={() => onChange(opt)}
              className="mr-2 radio radio-sm"
            />
            <label htmlFor={optionId} className="form-label !inline-flex cursor-pointer !mb-0">
              {opt}
            </label>
          </div>
        );
      })}
    </div>
  );
};

CustomFieldRadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
};
